import PropTypes from 'prop-types';
import React from 'react';

import useUser from 'site-react/hooks/useUser';

import GhostLoginBanner from './GhostLoginBanner';

const PageBanner = ({ children = null }) => {
  const { logout, parentUser, user } = useUser();

  if (parentUser) {
    return <GhostLoginBanner onLogout={logout} user={user} />;
  } else {
    return children;
  }
};

PageBanner.propTypes = {
  children: PropTypes.node,
};

export default PageBanner;
